import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { CHANNEL_TYPES } from '@kentik/ui-shared/notifications/constants';
import OttIcon from 'app/views/serviceProvider/ott/OttIcon';
import { ReactComponent as SlackLogoLight } from 'app/assets/logos/slack-logo.svg';
import { ReactComponent as SlackLogoDark } from 'app/assets/logos/slack-logo-dark.svg';

import { Flex, Text, Icon } from 'core/components';

@inject('$app')
@observer
class NotificationOption extends Component {
  renderTextLabel = (text) => (
    <Text muted small monospace fontWeight="bold" as="div" textTransform="uppercase" color="currentColor">
      {text}
    </Text>
  );

  get renderChannelIdentifier() {
    const { $app, option } = this.props;

    switch (option.channelType) {
      case CHANNEL_TYPES.SLACK:
        return $app.darkThemeEnabled ? <SlackLogoDark width={14} /> : <SlackLogoLight width={14} />;
      case CHANNEL_TYPES.EMAIL:
        return <Icon icon="envelope" size={14} />;
      case CHANNEL_TYPES.CUSTOM_WEBHOOK:
        return <OttIcon type="integration" value="webhooks" height="14px" useAlternateDarkLogo />;
      default:
        return this.renderTextLabel(option.channelType);
    }
  }

  render() {
    const { option } = this.props;
    const iconColor = option.disabled ? 'currentColor' : 'muted';

    return (
      <Flex alignItems="center" gap="6px" pl="5px">
        <Flex alignItems="center" gap="1px" color={iconColor}>
          {option.tenantID ? this.renderTextLabel('Tenant/') : ''}
          {this.renderChannelIdentifier}
        </Flex>
        <Text>{option.label}</Text>
      </Flex>
    );
  }
}

export default NotificationOption;
